<template>

    <v-layout column justify-center>

        <v-layout column fill-height pa-0 >

            <v-layout shrink px-0 pb-1 >

              <v-flex xs4 shrink px-0>
                    
                <v-text-field
                  :value="$t('device type')"
                  light
                  outline
                  flat
                  readonly
                  disabled
                  class="backgrey"
                  hide-details
                  :rows="1"
                  color="white"
                >

                </v-text-field>

              </v-flex>

              <v-flex xs8 shrink px-0>

                <v-select
                  :data-testid="$options.name + '__select__' + 'device type'"
                  v-model="current.type"
                  light
                  name="device type"
                  :items="getTypes"
                  item-text="id"
                  item-value="id"
                  outline
                  hide-details
                  class="white"
                  background-color="backgrey"
                  clearable

                >
                  <template v-slot:item="{ item, index }">
                    <span>{{ $t(item.id) }}</span>
                  </template>
                  <template v-slot:selection="{ item, index }">
                      <span>{{ $t(item.id) }}</span>
                  </template>
                </v-select>

              </v-flex>

            </v-layout>

          <v-layout shrink px-0 pb-1>

            <v-flex xs4 shrink px-0>
                  
              <v-text-field
                :value="$t('vendor')"
                light
                outline
                flat
                readonly
                disabled
                class="backgrey"
                hide-details
                :rows="1"
                color="white"
              >

              </v-text-field>

            </v-flex>

            <v-flex xs8 shrink px-0>

              <v-select
                :data-testid="$options.name + '__select__' + 'vendor'"
                v-model="current.vendor"
                light
                name="vendor"
                :items="getVendor"
                :no-data-text="$t('no vendors')"
                outline
                hide-details
                class="white"
                background-color="backgrey"
                clearable

              >
                <template v-slot:item="{ item, index }">
                  <span>{{ $t(item) }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                    <span>{{ $t(item) }}</span>
                </template>
              </v-select>

            </v-flex>

          </v-layout>

          <v-layout shrink px-0 pb-1>

            <v-flex xs4 shrink px-0>
                  
              <v-text-field
                :value="$t('available devices')"
                light
                outline
                flat
                readonly
                disabled
                class="backgrey"
                hide-details
                :rows="1"
                color="white"
              >

              </v-text-field>

            </v-flex>

            <v-flex xs8 shrink px-0>

              <v-select
                :data-testid="$options.name + '__select__' + 'device'"
                v-model="current.device"
                light
                name="vendor"
                :items="getDevice"
                :no-data-text="$t('no devices')"
                item-text="id"
                return-object
                outline
                hide-details
                class="white text-capitalize"
                background-color="backgrey"
                clearable

              >
                <template v-slot:item="{ item, index }">
                  <span>{{ $t(item.id) }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                    <span>{{ $t(item.id) }}</span>
                </template>
              </v-select>

            </v-flex>

          </v-layout>

          <v-expansion-panel
            light
            v-if="getCard"
            expand
            v-model="templatePanelOpen"
            class="my-2"
          >

            <v-expansion-panel-content lazy expand-icon=""
            :data-testid="$options.name + '__expansion-panel-content__' + 'template information'"
            >
              <template v-slot:header>
                <v-layout justify-center>
                  <span class="body-2 text-uppercase">{{$t('template information')}}</span>
                </v-layout>
              </template>
              <v-card flat>

                <v-flex v-for="(field, i) in getTemplateFields" :key="'templateField_' + i" px-2>
                  <v-layout v-if="field != 'children' && field != 'bridges' && field != 'deviceType' && field != 'cls' && field != 'id' && field != 'refs'" justify-space-between>
                    <span class="body-2 text-uppercase">{{$t(field) + ':  '}}  </span>
                    <span class="body-2 text-uppercase pl-3">{{$t(`${current.template[field]}`)}}</span>
                  </v-layout>

                </v-flex>

              </v-card>
            </v-expansion-panel-content>

          </v-expansion-panel>

          <v-flex v-if="getCard" pa-2>

            <div :style="`background-size: contain; height: 100%; width: 100%; backgroundImage: url(${this.getBackground(this.getCard.id)})`"></div>

          </v-flex>

        </v-layout>

    </v-layout>

</template>

<script lang="ts">
import Vue from 'vue'

// Типы
interface DeviceItem {
  id?: string
  name?: string
  width?: number
  height?: number
  depth?: number
  manufacturer?: string
  device_type?: string
  [key: string]: any
}

interface DevicesData {
  type: string[]
  vendor: string[]
  device: DeviceItem[]
}

interface CurrentState {
  type: string | null
  vendor: string[]
  device: DeviceItem | null
  template: DeviceItem | null
}

interface AcceptState {
  status: boolean
  message: string
}

interface ClosedUnit {
  position: number
  device: Array<{ mount?: string; depth?: number; [key: string]: any }>
  [key: string]: any
}

interface CabinetData {
  obj?: { depth?: number }
  [key: string]: any
}

interface DataProps {
  position?: number
  side?: string
  closed?: ClosedUnit[]
  cabinet?: CabinetData
  [key: string]: any
}

export default Vue.extend({
  name: 'CHOOSE_DEVICE',

  components: {},

  props: {
    data: {
      type: Object as () => DataProps,
      default: () => ({})
    },
  },

  data(): {
    devices: DevicesData
    current: CurrentState
    accept: AcceptState
    templatePanelOpen: boolean[]
  } {
    return {
      devices: {
        type: [],
        vendor: [],
        device: []
      },
      current: {
        type: null,
        vendor: [],
        device: null,
        template: null
      },
      accept: {
        status: true,
        message: 'Ok'
      },
      templatePanelOpen: [true]
    }
  },

  computed: {
    getData(): DataProps {
      return this.data
    },

    getTypes(): string[] {
      return this.devices.type
    },

    getVendor(): string[] {
      return this.devices.vendor
    },

    getDevice(): DeviceItem[] {
      if (this.current.vendor.length === 0) {
        return this.devices.device
      } else {
        return this.devices.device.filter(device => {
          return this.current.vendor.includes(device.manufacturer || '')
        })
      }
    },

    getCard(): DeviceItem | null {
      return this.current.device
    },

    getTemplateFields(): string[] {
      if (!this.current.template) return []
      return Object.keys(this.current.template).filter(key => key.substring(0, 1) !== '$')
    },
  },

  watch: {
    'current.type': {
      handler(newVal: string | null): void {
        if (!newVal) return
        this.current.device = null
        this.current.template = null
        this.$set(this.current, 'vendor', [])
        this.loadTemplates(newVal)
      },
      deep: true
    },
    'current.device': {
      handler(newVal: DeviceItem | null): void {
        if (!newVal) return
        if (this.checkSize(newVal)) {
          console.log('WATCH', this.$options.name, 'current.device', 'checked', newVal)
          this.current.template = []
          this.$set(this.current, 'template', newVal)
          const $obj = {
            cls: 'template',
            template: newVal,
            template_cls: 'device'
          }
          this.$emit('select', $obj)
        } else {
          console.log('WATCH', this.$options.name, 'current.device', 'checked', newVal, this.accept.message)
        }
      },
      deep: true
    },
    data: {
      handler(newVal: DataProps, oldVal: DataProps): void {
        if (newVal.position !== oldVal.position) {
          this.reset()
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadTypes()
    },

    async loadTypes(): Promise<void> {
      try {
        this.setLoader('loadTypes', true)
        const types = await this.$bridge.getEnum('devicetype')
        if (types) {
          console.log(this.$options.name, 'loadTypes', 'response', types)
          this.devices.type = []
          types.forEach((type: string) => {
            this.devices.type.push(type)
          })
        } else {
          console.log(this.$options.name, 'loadTypes', 'smth wrong', types)
        }
        this.setLoader('loadTypes', false)
      } catch (err) {
        console.log('CATCH', this.$options.name, 'loadTypes', err)
        this.setLoader('loadTypes', false)
      }
    },

    async loadTemplates(type: string): Promise<void> {
      try {
        this.setLoader('loadTemplates', true)
        const devices_$ = await this.$bridge.getTemplates('device', { device_type: type }) as DeviceItem[]
        if (devices_$) {
          console.log(this.$options.name, 'loadTemplates', 'response', devices_$)
          this.devices.device = []
          this.devices.vendor = []
          devices_$.forEach(device => {
            this.devices.device.push(device)
            if (device.manufacturer && !this.devices.vendor.includes(device.manufacturer)) {
              this.devices.vendor.push(device.manufacturer)
            }
          })
        } else {
          console.log(this.$options.name, 'loadTemplates', 'smth wrong', devices_$)
        }
        this.setLoader('loadTemplates', false)
      } catch (err) {
        console.log('CATCH', this.$options.name, 'loadTemplates', err)
        this.setLoader('loadTemplates', false)
      }
    },

    checkSize(val: DeviceItem): boolean {
      const position = Number(this.getData.position) || 0
      const closed = this.getData.closed || []
      const size = Math.ceil((val.height || 0) / 45)

      this.accept.status = true
      this.accept.message = 'Ok'

      if ((val.width || 0) > 490) {
        this.accept.status = false
        this.accept.message = 'Устройство не предназначено для установки в шкаф'
        this.$snotify.warning(`Внимание! Устройство ${val.id} не предназначено для установки в шкаф!`, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        })
        this.$emit('select')
        return false
      }

      if (position - size < 0) {
        this.accept.status = false
        this.accept.message = 'Размеры устройства превышают размеры доступного пространства'
        this.$snotify.warning(`Внимание! Размеры ${val.id} превышают размеры доступного пространства!`, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        })
        this.$emit('select')
        return false
      }

      for (let i = position; i > position - size; i--) {
        if (closed.some(unit => unit.position === i)) {
          if (closed.some(unit => unit.position === i && unit.device[0]?.mount === this.getData.side)) {
            this.accept.status = false
            this.accept.message = 'Размеры устройства превышают размеры доступного пространства'
            this.$snotify.warning(`Внимание! Размеры ${val.id} превышают размеры доступного пространства!`, {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            })
            this.$emit('select')
            return false
          }

          const newDevicePositions: number[] = []
          for (let i = position; i > position - size; i--) {
            newDevicePositions.push(i)
          }

          const cabinetDepth = this.getData.cabinet?.obj?.depth || 0
          const newDeviceDepth = val.depth || 0
          let currentDepth = 0

          closed.forEach(unit => {
            if (newDevicePositions.includes(unit.position) && (unit.device[0]?.depth || 0) > currentDepth) {
              currentDepth = unit.device[0]?.depth || 0
            }
          })

          if (currentDepth + newDeviceDepth <= cabinetDepth) {
            console.log(this.$options.name, 'checkSize', 'OK', cabinetDepth - newDeviceDepth - currentDepth)
            return true
          }

          this.accept.status = false
          this.accept.message = 'Размеры устройства превышают размеры доступного пространства'
          this.$snotify.warning(`Внимание! Размеры ${val.id} превышают размеры доступного пространства!`, {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          })
          this.$emit('select')
          return false
        }
      }

      return true
    },

    getBackground(data: DeviceItem): string {
      const path = this.$bridge.getImageLinkByTemplate('device', data, 'front')
      return path?.replace(/\s/g, '%20') || ''
    },

    reset(): void {
      this.current = {
        type: null,
        vendor: [],
        device: null,
        template: null
      }
      this.accept.status = true
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style scoped>
</style>
